export const tableMoreDotsMenu = {
  fontFamily: 'Poppins, sans-serif',
  borderRadius: '8px',
  backgroundColor: 'var(--bg-surface)',
  display: 'flex',
  gap: '10px',
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: '400',
  color: 'var(--text-primary)',
  marginBottom: '4px',
  '& svg': {
    width: '16px',
    height: '16px',
  },
  '&:hover': {
    backgroundColor: 'var(--bg-selected)',
    color: 'var(--primary)',
  },
  '&:hover svg': {
    filter:
      'invert(26%) sepia(25%) saturate(5553%) hue-rotate(217deg) brightness(94%) contrast(91%)',
  },
};

export const tableMoreDotsMenuPaper = {
  '& .MuiMenu-paper': {
    boxShadow: '0px 8px 24px rgba(149, 157, 165, 0.2)',
    borderRadius: '8px',
  },
};

export const searchAndSelect = {
  input: {
    color: 'var(--text-primary)',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    width: '100%',
    height: '100%',
  },
  '& input::placeholder': {
    fontFamily: 'Poppins, sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '24px',
    color: 'var(--text-secondary)',
    opacity: 1,
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'var(--text-secondary)',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '12px',
    border: '1px solid var(--border-strong)',
  },

  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      border: '1px solid var(--border-strong)',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid var(--primary)',
    },
  },
  '.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--danger)',
  },
};

export const searchAndSelectError = {
  ...searchAndSelect,
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '12px',
    border: '1px solid var(--danger)',
  },
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      border: '1px solid var(--danger)',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid var(--danger)',
    },
  },
};

export const pagination = {
  '& .MuiPaginationItem-root': {
    fontFamily: 'Poppins, sans-serif',
    fontSize: '14px',
    color: 'var(--text-primary)',
  },
  '& .Mui-selected': {
    backgroundColor: 'var(--primary) !important',
    color: 'var(--text-on-primary) !important',
    borderRadius: '3px',
    border: '1px solid var(--primary)',
    padding: '4px 3px 4px 3px',
    '&:hover': {
      backgroundColor: 'red',
    },
  },
};

export const tab = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '21.6px',
  borderBottom: '2px solid var(--border)',
  textTransform: 'capitalize',
  color: 'var(--text-primary)',
  '&.Mui-selected': {
    color: 'var(--primary)',
  },
};

export const switchLabel = {
  '& .MuiFormControlLabel-label': {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
    color: 'var(--text-primary)',
  },
};

export const createTaskBackupSwitchLabel = {
  '& .MuiFormControlLabel-label': {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: 'var(--text-secondary)',
  },
};

export const androidSwitch = {
  padding: 8,
  '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
    backgroundColor: 'var(--accent)',
    opacity: 1,
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'gray',
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
    backgroundColor: 'var(--bg-surface)',
  },
};

export const androidSwitchDisabled = {
  padding: 8,
  '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
    backgroundColor: 'var(--border)',
    opacity: 1,
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'gray',
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
    backgroundColor: 'var(--bg-surface)',
  },
};

export const selectRowsPaperProps = {
  sx: {
    marginTop: '8px',
    maxHeight: '200px',
    borderRadius: '12px',
    fontFamily: 'Poppins, sans-serif',
    boxShadow: 'var(--shadow-card)',
    '& .MuiMenuItem-root': {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: '400',
      padding: '8px 36px 8px 25px',
      fontSize: '14px',
      lineHeight: '24px',
      color: 'var(--text-primary)',
    },
    '& .MuiMenuItem-root.Mui-selected': {
      backgroundColor: 'var(--bg-selected)',
    },
    '& .MuiMenuItem-root:hover': {
      backgroundColor: 'var(--bg-selected)',
      color: 'var(--primary)',
    },
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--border)',
      borderRadius: '100px',
    },
  },
};

export const avatarMenuItemStyle = {
  color: 'var(--text-primary)',
  gap: '8px',
  borderRadius: '8px',
  '&:hover': {
    background: 'var(--bg-subtle)',
    '& img': {
      filter:
        'invert(22%) sepia(98%) saturate(1707%) hue-rotate(218deg) brightness(95%) contrast(90%)',
    },
    '& span': {
      filter:
        'invert(22%) sepia(98%) saturate(1707%) hue-rotate(218deg) brightness(95%) contrast(90%)',
    },
  },
};

export const calendarStyles = {
  width: '20%',
  '& input': {
    fontFamily: 'Poppins, sans-serif',
    color: 'var(--text-primary)',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    borderColor: 'var(--border-strong)',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '12px',
    border: '1px solid var(--border-strong)',
  },
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      border: '1px solid var(--border-strong)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--primary)',
    },
  },
  padding: '5px 0',
};

export const allBackupsStationsMenu = {
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  fontFamily: 'Poppins !important',
  minWidth: '18%',
  marginTop: '3px',
  borderRadius: '12px',
  '& .MuiMenu-paper': {
    fontFamily: 'Poppins !important',
  },
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--border)',
    borderRadius: '100px',
  },
};

export const allBackupsStationsMenuItem = {
  fontFamily: 'Poppins, sans-serif !important',
  color: 'var(--text-primary)',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '24px',
  padding: 0,
};

export const badgeStyles = {
  '& > span': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Poppins, sans-serif',
    padding: '8px',
    borderRadius: '100%',
    backgroundColor: 'var(--primary)',
    fontSize: '10px',
    color: 'var(--text-on-primary)',
    lineHeight: '15px',
    fontWeight: '400',
  },
};

export const chipStyles = {
  minWidth: '118px',
  maxHeight: '24px',
  color: 'var(--text-primary)',
  fontFamily: 'Poppins, sans-serif',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '20px',
  borderRadius: '10px',
  boxShadow: 'none',
  backgroundColor: 'var(--bg-selected)',
};

export const stationsChipClear = {
  fontFamily: 'Poppins, sans-serif',
  color: 'var(--primary)',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '400',
  textTransform: 'capitalize',
};

export const stationsChipClearIcon = {
  width: '24px',
  height: '24px',
  filter:
    'invert(26%) sepia(31%) saturate(4223%) hue-rotate(215deg) brightness(96%) contrast(93%)',
};

export const muiSelectElementsCount = {
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          color: 'var(--text-secondary)',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '24px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid var(--border-strong)',
            borderRadius: '12px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: '1px solid var(--border-strong)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid var(--primary)',
          },
        },
      },
    },
  },
};
